import React from "react";
import ClientSummary from "../Monitoring/ClientSummary";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useSearchParams } from "react-router-dom"
import AvayaCallData from "./ViewModels/AvayaCallData";


export default function MemoContainer() {
    const [searchParams] = useSearchParams();
    const callRefId = searchParams.get('callRefId') ?? '';
    const systemId = searchParams.get('systemId') ?? '';
    const avayaCallData = new AvayaCallData(
        searchParams.get('phoneNumber') ?? '',
        searchParams.get('time') ?? '',
        searchParams.get('result') ?? '',
    );

    return (
        <>
            {
                callRefId && systemId ?
                    <Grid container padding={1} sx={{ height: '100%', overflowY: 'scroll' }}>
                        <ClientSummary
                            callRefId={callRefId}
                            systemId={systemId}
                            avayaCallData={avayaCallData}
                            memoView />
                    </Grid>
                    :
                    <Grid
                        container
                        justifyContent='center'
                        alignItems='center'
                        height='100vh'>
                        <Grid>
                            <Typography variant='h4'>Invalid URL</Typography>
                        </Grid>
                    </Grid>
            }
        </>
    );
};